export default "__VITE_ASSET__7b38b70b__"